module.exports = __webpack_public_path__ + "src/assets/fonts/4b5b90deb1ba9887160f88ad0abc4fc2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/4b5b90deb1ba9887160f88ad0abc4fc2.woff
// module id = 566
// module chunks = 58